// Frontend configuration
// API_URL can be configured via VITE_API_URL environment variable

export const config = {
  // In development with proxy: '/api'
  // In production or with reverse proxy: 'https://api-chat.meridiankiosks.com'
  apiUrl: import.meta.env.VITE_API_URL || '/api',
};
